import React, { useCallback } from 'react';
import { observer } from 'mobx-react';
import { Left } from '@icon-park/react';
import Styles from './index.module.scss';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

interface Nav {
  key?: string;
  list: Array<{key?: string; name: string; url?: string; active?: boolean}>;
  style?: React.CSSProperties;
  back?: string | Function;
  onClick?: Function;
}

const Navigation: React.FC<Nav> = ({
  list, back, style, onClick,
}) => {
  const { t } = useTranslation();
  const history = useHistory();

  const navBack = useCallback(() => {
    if (typeof back === 'string') {
      history.push(back);
    } else if (back) {
      back();
    }
  }, []);

  const clickItem = useCallback((item) => {
    if (item.url) {
      history.push(item.url);
    }
    if (onClick) {
      onClick(item);
    }
  }, []);

  return (
    <div className={Styles.navigation} style={style}>
      <div className={Styles.navigationLeft} onClick={navBack}>
        <Left fill="#999" style={{ margin: '0 4px' }} size="16px" />
        <span>{t('back')}</span>
      </div>
      <div className={Styles.navigationRight}>
        {
          list.map((item) => (
            <span
              key={item.name}
              className={item.active ? Styles.active : ''}
              onClick={() => { clickItem(item); }}
            >
              {t(item.name)}
            </span>
          ))
        }
      </div>
    </div>
  );
};

export default React.memo(observer(Navigation));
